/**
 * Activity Planner row permissions.
 * SCHOOLE / SUPERADMIN: mutate any school row.
 * TEACHER: mutate rows they created (createdBy user id).
 * Rows with no createdBy (legacy / unowned): any teacher may mutate.
 */

const normalizeId = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'object' && value._id != null) return String(value._id);
  return String(value);
};

const getUserDetails = (userDetails) => {
  if (userDetails) return userDetails;
  try {
    return JSON.parse(localStorage.getItem('userDetail') || '{}');
  } catch (e) {
    return {};
  }
};

export function canMutatePlannerActivity(record, userDetails) {
  const user = getUserDetails(userDetails);
  const role = String(user?.role || '').toUpperCase();
  if (role === 'SUPERADMIN' || role === 'SCHOOLE') return true;
  if (role !== 'TEACHER') return false;

  const currentUserId = normalizeId(user?._id);
  const ownerUserId = normalizeId(record?.createdBy);

  // Once a row records its creator, that creator is the only teacher who may
  // mutate it — being assigned to the row does not grant edit/delete.
  if (ownerUserId) {
    return Boolean(currentUserId) && ownerUserId === currentUserId;
  }

  // No createdBy (shown as "—" in the UI): open to any teacher.
  return true;
}
